import { render } from "./Warnings.vue?vue&type=template&id=ac0447cc&scoped=true"
import script from "./Warnings.vue?vue&type=script&lang=js"
export * from "./Warnings.vue?vue&type=script&lang=js"

import "./Warnings.vue?vue&type=style&index=0&id=ac0447cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac0447cc"]])

export default __exports__